export const THROTTLE_LIMIT = 200;
export const OVERLAPPING_THRESHOLD = 10;
